export const SEND_HUBSPOT_FORM = 'sendHubspotForm'
export const SEND_HUBSPOT_FORM_DONE = 'sendHubspotFormDone'
